import React from 'react';
import AuthLayout from './AuthLayout';
import { Button, Checkbox, Form, Input, message } from 'antd';
import SubmitBtn from './SubmitBtn';
import { useNavigate } from 'react-router-dom';
import useUserSignUp from '../../_hooks/useUserSignUp';
import { observer } from 'mobx-react-lite';

const Register = observer(() => {
    return (
        <div>
            <AuthLayout
                title="Sign Up"
                subtitle="Create an account"
                content={<RegisterForm />}
            />
        </div>
    );
});
export default Register;

export const RegisterForm = observer(() => {
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const [isChecked, setIsChecked] = React.useState(false);
    const { signUpWithCognito, isLoading } = useUserSignUp();
    const onFinish = (values) => {
        const user = {
            firstName: values.firstName,
            lastName: values.lastName,
            email: values.email,
            password: values.password,
        };

        signUpWithCognito(values)
            .then((result) => {
                message.success('Verification code sent to your email');
                navigate('/auth/verify-email', {
                    state: { email: user.email },
                });
            })
            .catch((error) => {
                message.error(error.message);
            });
    };

    return (
        <>
            <Form
                form={form}
                name="login"
                layout="vertical"
                onFinish={onFinish}
                requiredMark={false}
                autoComplete="off"
                className="auth-form-antd">
                <div className="flex gap-[24px]">
                    <Form.Item
                        name="firstName"
                        label="First Name *"
                        className="mb-[16px]"
                        rules={[
                            {
                                required: true,
                                message: 'Please enter a first name!',
                            },
                        ]}>
                        <Input
                            placeholder="Enter your first name"
                            className="auth-form-antd-form-item"
                        />
                    </Form.Item>
                    <Form.Item
                        name="lastName"
                        label="Last Name *"
                        className="mb-[16px]"
                        rules={[
                            {
                                required: true,
                                message: 'Please enter a last name!',
                            },
                        ]}>
                        <Input
                            placeholder="Enter your last name"
                            className="auth-form-antd-form-item"
                        />
                    </Form.Item>
                </div>

                {/* Email */}
                <Form.Item
                    name="email"
                    label="Email *"
                    className="mb-[16px]"
                    rules={[
                        {
                            required: true,
                            type: 'email',
                            message: 'Please enter a  email address!',
                        },
                    ]}>
                    <Input
                        placeholder="Enter your email address"
                        className="auth-form-antd-form-item"
                        autoComplete="username"
                    />
                </Form.Item>

                {/* Password */}
                <Form.Item
                    className="mb-[16px]"
                    name="password"
                    label="Password *"
                    rules={[
                        {
                            required: true,
                            message: 'Please enter your password!',
                        },
                    ]}>
                    <Input.Password
                        placeholder="Enter your password"
                        className="auth-form-antd-form-item"
                        autoComplete="current-password"
                    />
                </Form.Item>

                <Form.Item
                    className="mb-[16px]"
                    name="confirm"
                    label="Confirm Password *"
                    dependencies={['password']}
                    rules={[
                        {
                            required: true,
                            message: 'Please confirm your password!',
                        },
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (
                                    !value ||
                                    getFieldValue('password') === value
                                ) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(
                                    new Error('Passwords do not match!'),
                                );
                            },
                        }),
                    ]}>
                    <Input.Password
                        placeholder="Confirm your password"
                        className="auth-form-antd-form-item"
                        autoComplete="current-password"
                    />
                </Form.Item>

                <div className="font-favorit   w-full flex items-center gap-[10px] h-[24px] cursor-pointer mb-[16px]">
                    <Checkbox
                        className="custom-checkbox"
                        checked={isChecked}
                        onChange={(e) => setIsChecked(e.target.checked)}
                    />
                    <p className="text-[14px] text-[#5B5F5D] leading-[14px] ">
                        I agree to the{' '}
                        <span className="text-theme-orange">
                            terms of service{' '}
                        </span>
                        and{' '}
                        <span className="text-theme-orange">
                            privacy policy
                        </span>
                    </p>
                </div>

                {/* Submit Button */}
                <Form.Item className="mb-[16px]">
                    <SubmitBtn
                        label="Sign Up"
                        isLoading={isLoading}
                        disabled={!isChecked}
                    />
                </Form.Item>
            </Form>

            <div className="font-favorit text-[14px] w-full text-center text-[#5B5F5D]">
                All ready have an account? please{' '}
                <span
                    className="text-theme-orange cursor-pointer hover:underline"
                    onClick={() => navigate('/auth/login')}>
                    Sign In
                </span>{' '}
            </div>
        </>
    );
});
